<template>
  <div class="top-up-method-container p-4 flex items-center justify-center">
    <div class="rounded-lg card w-full overflow-y-auto py-6 sm:px-8 px-6 vs-con-loading__container">
      <div class="flex items-center justify-end mb-4">
        <p @click="closeModal" class="material-symbols-outlined cursor-pointer text-2xl">close</p>
      </div>
      <div class="flex sm:flex-row flex-col gap-6 items-center pb-8">
        <div>
          <p class="font-semibold sm:text-3xl text-xl text-primary mb-7">{{$t('Your Gateway to Swift Cash Flow Awaits')}}</p>
          <p class="text-black">{{$t('Get ready to transform the way you access and withdraw your confirmed collected cash from Cash on Delivery (COD) orders. This is designed to empower you to reinvest in your business, manage your finances effectively, and stay ahead in the fast-paced world of eCommerce.')}}</p>
        </div>
        <div>
          <img class="sm:block hidden" src="@/assets/images/pages/flash.svg" height="180">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    closeModal () {
      this.$emit('instantPayoutModal', false)
    }
  }
}
</script>